module.exports = __webpack_public_path__ + "static/media/1.66c2456c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/1037/1.jpg
// module id = 417
// module chunks = 0